import { API } from "../../lib/api";

export const ROLES = ["Portiere", "Difensore", "Centrocampista", "Attaccante"];

export const emptyPlayer = {
  first_name: "",
  last_name: "",
  birth_date: "",
  jersey_number: "",
  role: "",
  photo: "",
  parent_name: "",
  parent_phone: "",
  parent_email: "",
  size: "",
  medical_notes: "",
  notes: "",
  figc_card_number: "",
  figc_id: "",
  figc_document: "CRT-SGS",
  fiscal_code: "",
};

export function photoSrc(photo) {
  if (!photo) return "";
  if (photo.startsWith("data:") || photo.startsWith("http")) return photo;
  if (photo.startsWith("/api/")) return `${API.replace(/\/api$/, "")}${photo}`;
  return photo;
}
